import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable()
export class RouteGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    const token = localStorage.getItem('token');
    const userStatus = localStorage.getItem('companyStatus');
    if (token && userStatus === 'APPROVED') {
      return true;
    } 
    this.redirectTo('/auth/sign-in');
    return false;
    }
  
    private redirectTo(route: string): void {
      this.router.navigate([route]);
    }
  }

